import React, { useContext, useState, useEffect } from 'react';
import HeaderForm from './headerformnurse';
import DownloadIcon from '@mui/icons-material/Download';
import {
    Navigate,
    useNavigate,
    Link
  } from "react-router-dom";

  import VisibilityIcon from '@mui/icons-material/Visibility';
  import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


import { useDispatch } from "react-redux";
import { AppContext } from '../context';

import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { toast } from "react-toastify";

 const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));
  
  function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;
  
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }



function Applicationstatusparent (props) {

 const [manageapplicationstatusList, setManagApplicationsStatusList] = useState([]);
   const [firstLoading, setFirstLoading] = useState(true);
  const [loader, setLoader] = useState(false);
const[reason,setReason]=React.useState(false)
const[reasondeatils,setReasonDeatils]=React.useState('');
const[nursedata,setNursedata]=React.useState('');
  const { storage } = useContext(AppContext);
   const Axios = axios.create({
    baseURL: storage[0].backEndUrl
    // baseURL: process.env.REACT_APP_ENV_URL
  });
  let navigate = useNavigate();

 useEffect(() => {
  
    var user = JSON.parse(window.localStorage.getItem('nursedata'));
 
    if (Object.keys(user).length === 0) {
      //  navigate(`/`);
    } else {
      setNursedata(user);
      loadApplications();


    }

  }, []);

 const loadApplications = () => {
    var usernew = JSON.parse(window.localStorage.getItem('nursedata'));
   setNursedata(usernew);
    Axios.post(`/appication_status_list`, {  location: usernew.location,nurse_id: usernew.empid })
    .then(res => {

      console.log("eform");
      console.log(res.data);
      // setTotalCount(res.data.pagination.totalCount);
      // setTotalPage(res.data.pagination.totalPage);
      if(res.data.status==true){
        if (res.data.message.length > 0) {
        setManagApplicationsStatusList(res.data.message);
      }else {
        setManagApplicationsStatusList([]);
      }
      }
      
      
      setFirstLoading(false);
    });
  }

const handlereason = (consent_form) =>{
setReasonDeatils(consent_form);
  setReason(true);
  
}
const handleCloselogss = () => setReason(false);


  return (
    <>
     <HeaderForm />
     
      <div className='regis-main-sec forms-main-sec'>
    <div className='container-fluid'>

        <div className='row'>
            <div className='col-md-12'>
                <div className='regis-head forms-heading-sec'>
                    <h2>Application Status {props.name}</h2>

                    <Link to="/application">  <p className='stts-sec view-sts'>View Application List</p></Link>
                  
                </div>
            </div>
        </div>
        <div className='row'>
            <div className='col-md-12'>
            <div className='club-sec application-sec'>
          <div className='container-fluid '>
         
          <div className='club-inner-secss form-table-sec table-section-route table-form appl-sec'>
          <div className='row'>
              <div className='col-md-12'>
                <div className='indicate-secss'>
                <p className='style-new'><span className='square-secss'>A - </span><span style={{color:'#059652',fontWeight:'700'}}>Approved</span></p>
                <p><span className='square-sec-redss'>R - </span><span style={{color:'#fb0b0b',fontWeight:'700'}}>Rejected</span></p>
                </div>

                </div>
              </div>  
            <div className='row'>
               <div className='col-md-12'>
                <table class="table table-bordered">
                <thead class="thead-light thead-travel thead-form">
                <tr>
                 
                  <th className='loc-width'>Location</th>
                  <th className='std-id-width'>Student ID</th>
                  <th className='std-name-width'>Student Name</th>
                  <th className='grade-width'>Grade</th>
                  <th className='date-width'>Parent Consent Form</th>
                  <th className='date-width'>Physician Form</th>
                  <th className='stts-width'>Status</th>
                  {/* <th className='action-width'>Action</th> */}
               </tr>
               </thead>
               <tbody className='tbody-light tbody-form'>
                 {                                                                
                              firstLoading ? <tr ><td colSpan={7}><div className="spinner-border" role="status" style={{ width: "1rem", height: "1rem", marginLeft: "6px" }}></div></td></tr> : <>
                                {manageapplicationstatusList.length > 0 ?

                                  manageapplicationstatusList.map((userd, index) =>
                                   <tr key={index}>
                    
                    <td>{userd.school_name}</td>
                    <td className='std-id'>{userd.stuid}</td>
                    <td>{userd.student_name} {userd.last_name}</td>
                    <td>{userd.stu_grade}</td>
                    <td><p className='form-comp'>
                             {userd.document_details.length >0 && userd.document_details.length}
                              
                    <span className={` ${(userd.document_details.length >0 && userd.document_details.length!=9) && 'red-down'} ${(userd.document_details.length >0 && userd.document_details.length==9) && 'blue-down'}`}><DownloadIcon 
                    /></span></p>
                    
                    </td>
                    <td><p className='form-comp'>
                    
                             {userd.physician_document_details.length >0 && userd.physician_document_details.length}
                              {userd.physician_document_details.length>0 &&
    <span className={`  ${(userd.physician_document_details.length >0) && 'blue-down'}`}><DownloadIcon 
                    /></span>
                              }
                   
                    </p>
                    </td>
                   <td> <span className=
                   {`green-down  ${(userd.consent_details.status=='Rejected') && 'square-sec-redss'}`} style={{fontWeight:'700',fontSize:'18px'}}>
                  {(userd.consent_details.status=='Rejected') && 'R'}
                   {(userd.consent_details.status=='Approved') && 'A'}</span><span className='visib-sec'
                    onClick={() => handlereason(userd.consent_details)}><VisibilityIcon /></span></td>
                  
                </tr>
                                  )

                                  : <tr><td colSpan={7}>No Data Found</td></tr>}
                              </>
                            }
                           
               </tbody>
               </table>
               </div>
            </div>
            
            </div>
          </div>
          </div>
            </div>
        </div>
    </div>
    </div>

       {/* modal section start */}
       
       <BootstrapDialog
          onClose={handleCloselogss}
          aria-labelledby="customized-dialog-title"
          open={reason} className="route-view copy-view logout-view login-modal app-modal resn-modl">
          <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloselogss}>
            {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec' style={{ paddingTop: '0px' }}> 
               {reasondeatils!=null && reasondeatils!='' &&
               <>
               <h2 className='uplod-secddd'>Reason For  {reasondeatils.status=='Approved' && 'Approve'} {reasondeatils.status=='Rejected' && 'Rejection'}</h2>
                <p className='uplod-para'>{reasondeatils.reason}</p>
                </>
             }
                
              </div>

            
             
            </Typography>
          </DialogContent>
        </BootstrapDialog>
        {/* modal section end */}


    </>
  )
}
export default Applicationstatusparent;